<template>
  <div
    class="rs-searchautocomplete__vue"
    :class="{
      'rs-searchautocomplete__vue__has-content':
        fetchedResults.suggestions && fetchedResults.suggestions.length,
    }"
  >
    <button
      class="rs-searchautocomplete__vue__term"
      v-for="(item, index) in fetchedResults.suggestions"
      :key="index"
      @click="selectTerm(fetchedResults.prefix + item.term)"
      ref="termButtons"
    >
      <svg width="20.001" height="20.001" viewBox="0 0 20.001 20.001">
        <path
          d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
          transform="translate(0 17.5)"
          fill="#652981"
        />
      </svg>
      <span
        class="rs-searchautocomplete__vue__term__suggestion"
      >{{ fetchedResults.prefix }} {{ item.term }}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    searchKeywords: String,
  },
  data: function () {
    return {
      fetchedResults: {},
      fetchResultsAbortController: undefined,
      isLoading: false,
      highlightedTermIndex: 0,
    };
  },
  computed: {
    
  },
  watch: {
    searchKeywords() {
      // this.fetchResults();
    },
  },
  mounted: function () {
    this.$el.addEventListener("keydown", (event) => {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        this.highlightNextTerm();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        this.highlightPreviousTerm();
      }
    });
  },
  methods: {
    fetchResults() {
      let endpoint = "/wp-json/rs/v1/search-autocomplete";
      if (this.searchKeywords.length) endpoint += "/" + this.searchKeywords;

      if (this.fetchResultsAbortController)
        this.fetchResultsAbortController.abort();

      this.fetchResultsAbortController = new AbortController();
      let signal = this.fetchResultsAbortController.signal;

      this.isLoading = true;

      fetch(endpoint, { signal })
        .then((response) => response.json())
        .then((data) => {
          this.fetchedResults = data; this.fetchedResults.suggestions = this.fetchedResults.suggestions.sort((a, b) => a.term.localeCompare(b.term));
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.log(error);
          }
        });
    },
    selectTerm(term) {
      this.window.rsSearchAutocompleteVue_OnSelectTerm(term);
    },

    takeKeyboardFocus() {
      this.highlightedTermIndex = 0;
      this.highlightNextTerm();
    },

    highlightNextTerm() {
      if (this.highlightedTermIndex < this.$refs["termButtons"].length) {
        this.highlightedTermIndex++;
        this.$refs["termButtons"][this.highlightedTermIndex - 1].focus();
        window.rsShowAutocomplete();
      } else {
        // console.log("hit the end");
      }
    },

    highlightPreviousTerm() {
      if (this.highlightedTermIndex == 1) {
        window.rsSearchInputTakeKeyboardFocus();
      } else {
        this.highlightedTermIndex--;
        this.$refs["termButtons"][this.highlightedTermIndex - 1].focus();
      }
    },
  },
};
</script>
